import { useParams } from "react-router-dom";
import { PolicyDetail } from "@/features/oversight/governance";

export default function GovernancePolicyPage() {
  const { id } = useParams();
  return <PolicyDetail id={id!} />;
}
